"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var EmptyStateSymbol = require('../icons/empty_image_medium.svg.js');

var SecondaryMediaImage = /*#__PURE__*/function (_React$Component) {
  _inherits(SecondaryMediaImage, _React$Component);

  var _super = _createSuper(SecondaryMediaImage);

  function SecondaryMediaImage(props) {
    var _this;

    _classCallCheck(this, SecondaryMediaImage);

    _this = _super.call(this, props);

    _this.getClassName = function () {
      return "".concat(_this.props.getClassName('control-secondary-media-image'), " ").concat(_this.props.src || _this.props.children ? 'has-img' : 'no-img');
    };

    _this.getStyle = function () {
      return {
        backgroundImage: "url(".concat(_this.props.src, ")"),
        backgroundRepeat: _this.props.repeat ? 'repeat' : 'no-repeat'
      };
    };

    return _this;
  }

  _createClass(SecondaryMediaImage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        onClick: this.props.onClick,
        style: this.getStyle()
      }, !this.props.src && !this.props.children ? /*#__PURE__*/React.createElement(EmptyStateSymbol, {
        key: "emptyStateSymbol"
      }) : null, !this.props.src && this.props.children ? /*#__PURE__*/React.createElement("div", {
        className: "children-container",
        key: "children-container"
      }, this.props.children) : null);
    }
  }]);

  return SecondaryMediaImage;
}(React.Component);

SecondaryMediaImage.displayName = displayNames.SECONDARY_MEDIA_IMAGE;
SecondaryMediaImage.propTypes = {
  /** Url for the image */
  src: PropTypes.string,

  /** Callback function, triggered on image click*/
  onClick: PropTypes.func,

  /** When `true` the image will be displayed as background repeat */
  repeat: PropTypes.bool
};
SecondaryMediaImage.defaultProps = {
  repeat: false
};
module.exports = compose(SecondaryMediaImage);